module.exports = __webpack_public_path__ + "static/23gde-5674f0b0ab5455b95fd8aeecb0739ead.gif";